<div>
    <div class="tab__title">{{ 'userAddress' | translate }}</div>
    <div class="tab__subtitle">{{ userDetail()?.name || '' }}</div>
    <div class="tab__subtitle">{{ userDetail()?.gid || '' }}</div>

    @if (userDetail(); as userDetailValue) {
        <app-tab-person-detail [location]="location()" [userDetail]="userDetailValue"></app-tab-person-detail>
    }
</div>
